export enum GemiTuru {
    milliGemiSicilineKayitliGemiler = "milliGemiSicilineKayitliGemiler",
    turkUluslararasiGemiSicilineKayitliGemiler = "turkUluslararasiGemiSicilineKayitliGemiler"
}

export enum GemiTuruLabel {
    milliGemiSicilineKayitliGemiler = "Milli Gemi Siciline Kayıtlı Gemiler",
    turkUluslararasiGemiSicilineKayitliGemiler = "Türk Uluslararası Gemi Siciline Kayıtlı Gemiler"
}